var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09375 12.1875C2.73354 12.1875 0 9.45374 0 6.09375C0 2.73376 2.73354 0 6.09375 0C9.45396 0 12.1875 2.73376 12.1875 6.09375C12.1875 9.45374 9.45396 12.1875 6.09375 12.1875ZM6.09375 0.9375C3.25058 0.9375 0.9375 3.25058 0.9375 6.09375C0.9375 8.93692 3.25058 11.25 6.09375 11.25C8.93692 11.25 11.25 8.93692 11.25 6.09375C11.25 3.25058 8.93692 0.9375 6.09375 0.9375Z",
    fill: "#EF5B5B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0712 10.54C9.95129 10.54 9.83136 10.4942 9.73981 10.4027L1.78479 2.44766C1.60168 2.26456 1.60168 1.96793 1.78479 1.78482C1.9679 1.60172 2.26453 1.60172 2.44763 1.78482L10.4026 9.73984C10.5858 9.92294 10.5858 10.2196 10.4026 10.4027C10.3111 10.4942 10.1912 10.54 10.0712 10.54Z",
    fill: "#EF5B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.06c44eef80523fa588f76dc97d8ee74b.svg";
export { ForwardRef as ReactComponent };